import { UXBlock } from '../../../core/models/ux-page';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { Router } from '@angular/router';
var BlockComponent = /** @class */ (function () {
    function BlockComponent(analyticsSvc, router) {
        this.analyticsSvc = analyticsSvc;
        this.router = router;
        this.type = 'default';
        this.blocksCount = 0;
    }
    Object.defineProperty(BlockComponent.prototype, "classes", {
        get: function () {
            if (this.blocksCount <= 1)
                return 'col-md-12 col-sm-12';
            if (this.blocksCount === 2)
                return 'col-md-6 col-sm-6';
            if (this.blocksCount === 3)
                return 'col-md-4 col-sm-12';
            if (this.blocksCount === 4)
                return 'col-md-3 col-sm-6';
            if (this.blocksCount === 5)
                return 'col-md-4 col-sm-4 ';
            if (this.blocksCount >= 6)
                return 'col-md-3 col-sm-6';
        },
        enumerable: true,
        configurable: true
    });
    BlockComponent.prototype.onClick = function () {
        if (this.hasExternalLink) {
            window.open(this.block.externalLink, '_blank');
        }
        else if (this.hasLink) {
            this.analyticsSvc.event('click', { event_category: 'Homeblock', event_label: this.title });
            this.router.navigate([this.buttonLink]);
        }
    };
    Object.defineProperty(BlockComponent.prototype, "hasImage", {
        get: function () {
            return !!this.block.img;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "image", {
        get: function () {
            return this.block.img;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "title", {
        get: function () {
            return this.block.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "hasSubtitle", {
        get: function () {
            return !!this.block.subTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "subtitle", {
        get: function () {
            return this.block.subTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "hasLink", {
        get: function () {
            return !!this.block.link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "hasExternalLink", {
        get: function () {
            return !!this.block.externalLink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "content", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "buttonLink", {
        get: function () {
            return "/" + this.block.link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockComponent.prototype, "buttonText", {
        get: function () {
            return this.block.buttonText;
        },
        enumerable: true,
        configurable: true
    });
    return BlockComponent;
}());
export { BlockComponent };
